import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_menu-import",
  "use": "svg_menu-import-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_menu-import\"><path d=\"M16 0H1.99C.88 0 .01.9.01 2L0 16c0 1.1.88 2 1.99 2H16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 12h-3.997c0 1.66-1.35 3-2.998 3a3.001 3.001 0 0 1-2.998-3H2V2h14v10zm-3-5h-2V4H7v3H5l4 4 4-4z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol